import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import contactAPI from '../../api/contact';
import { Types, Creators } from '../../reducers/product';
import getState from '../../utils/getState';

function* notifyMeRequest({ mail, name }) {
  const {
    product,
    customer,
    app: { config = {} },
  } = yield select(getState);

  const { siteId } = config;

  try {
    const params = {
      IDPRODUCT: product.getIn(['currentSku', 'id']),
      SKU: product.getIn(['currentSku', 'id']),
      customer: customer.getIn(['id']),
      mail,
      name,
      opt: 'in',
      o: config.getIn(['notifyMe', 'origin']),
      m: config.getIn(['seller']),
      event_name: 'CR_AVISE_ME',
      event_id: config.getIn(['notifyMe', 'unavailableProduct']),
      send_email: true,
    };

    yield call(contactAPI.sendNewsletter, params, siteId);

    yield put(Creators.notifyMeSuccess());
  } catch (error) {
    yield put(Creators.notifyMeFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.NOTIFY_ME_REQUEST, notifyMeRequest);
}
